import React, {useState, useEffect, useRef} from "react";
import {Container, Row, Col, Card, CardBody} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import {OverlayTrigger, Tooltip} from 'react-bootstrap';

import {Link} from "react-router-dom";
import AuthService from "../login/AuthService";
import ApiService from "../util/ApiService";
import Swal from "sweetalert2";
import moment from "moment";
import {Avatar, Button, DatePicker, Input, Pagination} from "antd";
import locale from "antd/es/date-picker/locale/pt_BR";
import Skeleton from "react-loading-skeleton";
import "bootstrap/dist/css/bootstrap.min.css";
import {Modal} from "bootstrap";
import Select from "react-select";

import DocumentDocTypeModal from './DocumentDocTypeModal';
import DocumentSelectRequiredModal from "./DocumentSelectRequiredModal";
import ImportModal from "../import/ImportModal";
import AnalysisUserModal from "./AnalysisUserModal";
import "./assets/css/Accreditation.css";
import UsersSearch from "../dashboard/calender/UsersSearch";
import UserRegisterModal from "./UserRegisterModal";
import CustomPagination from "../util/CustomPagination";
import ModalCompanyConfigAccreditation from "./ModalCompanyConfigAccreditation";
import AccreditationCommentsModal from "./AccreditationCommentsModal";
import dayjs from "dayjs";
import DropdownPortal from "../util/DropdownPortal";
import SpecialtiesUserModal from "../Specialties/SpecialtiesUserModal";
import DepartmentUserModal from "../Department/DepartmentUserModal";

const {RangePicker} = DatePicker;

const statusOptions = [
    {value: 'pending', label: 'Pendente'},
    {value: 'accepted', label: 'Aprovado'},
    {value: 'refused', label: 'Rejeitado'},
    {value: 'due_date', label: 'vencido'},
];

const AccreditationCompany = () => {

    document.title = "Credenciamento | Plantão Rápido";

    const selectInputRef = useRef();
    const [showDepartmentUserModal, setShowDepartmentUserModal] = useState(false);
    const [showSpecialtiesUserModal, setShowSpecialtiesUserModal] = useState(false);
    const [specialtyOptions, setSpecialtyOptions] = useState([]);
    const buttonRefs = useRef({});
    const [dropdownOpenId, setDropdownOpenId] = useState(null);

    const [departmentsFilter, setDepartmentsFilter] = useState([]);

    const [showUserRegisterModal, setShowUserRegisterModal] = useState(false);
    const [showDocTypeModal, setShowDocTypeModal] = useState(false);
    const [showCommentsModal, setShowCommentsModal] = useState(false);
    const [showSelectDocTypeModal, setShowSelectDocTypeModal] = useState(false);
    const [showImportModal, setShowImportModal] = useState(false);
    const [dataConfig, setDataConfig] = useState(false);
    const [tipoData, setTipoData] = useState("updated_at"); // "cadastro" ou "vencimento"

    const [showConfigModal, setShowConfigModal] = useState(false);
    const [showAnalysisUserModal, setShowAnalysisUserModal] = useState(false);
    const [docTypeModalData, setDocTypeModalData] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);


    const [arrayCompany, setArrayCompany] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchFilters, setSearchFilters] = useState({
        dateRange: [],
        status: "",
        user_id: "",
        number_contract: "",
    });
    const [pagination, setPagination] = useState({current: 1, pageSize: 10, total: 0, lastPage: 0});

    useEffect(() => {
        fetchArrayCompany();
        fetchListCompanyAssistant();
        fetchSpecialties();
        fetchDepartmentsFilter();
    }, []);


    const fetchDepartmentsFilter = async () => {
        try {

            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}departments/list-department`,
                {
                    all: true,
                    status: 'S'
                },
                true
            );

            if (response.code === 200) {

                const {data} = ApiService.handleApiResponse(response);

                setDepartmentsFilter(
                    Array.isArray(data) ? data : []
                );
            } else {
                Swal.fire("Erro", "Erro ao carregar os departamentos.", "error");
            }
        } catch (error) {
            ApiService.handleApiError(error);
            setDepartmentsFilter([]);
        }
    };


    const fetchSpecialties = async () => {
        try {
            const storedSpecialties = localStorage.getItem("specialties-select");

            if (storedSpecialties) {
                setSpecialtyOptions(JSON.parse(storedSpecialties));
            } else {
                const response = await ApiService.send('get', `${process.env.REACT_APP_URL_API}specialties/list`);

                const {data} = ApiService.handleApiResponse(response);

                const options = data.map(specialty => ({
                    value: specialty.id,
                    label: specialty.name,
                }));
                localStorage.setItem("specialties-select", JSON.stringify(options));
                setSpecialtyOptions(options);
            }
        } catch (error) {
            ApiService.handleApiError(error);
        }
    };

    const handleShowDocTypeModal = (data = null) => {
        handleHideSelectDocTypeModal();
        setDocTypeModalData(data);
        setShowDocTypeModal(true);
    };

    const handleShowDepartmentUserModal = (data = null) => {
        setShowDepartmentUserModal(true);
        setSelectedUser(data);
    };

    const handleShowSpecialtiesUserModal = (data = null) => {
        setShowSpecialtiesUserModal(true);
        setSelectedUser(data);
    };

    const handleShowSelectDocTypeModal = (data = null) => {
        setShowSelectDocTypeModal(true);
    };

    const handleShowConfigModal = () => {
        setShowConfigModal(true);
    };

    const handleHideConfigModal = () => {
        setShowConfigModal(false);
    };


    const handleHideDocTypeModal = () => {
        setShowDocTypeModal(false);
    };
    const handleHideSelectDocTypeModal = () => {
        setShowSelectDocTypeModal(false);
    };

    const handleHideImportModal = () => {
        setShowImportModal(false);
    };

    const handleHideAnalysisUserModal = (save) => {
        setShowAnalysisUserModal(false);
        if (save) {
            fetchArrayCompany();
        }
    };


    const fetchArrayCompany = async (page = 1, isExport = false) => {

        setLoading(true);

        try {
            // Define o responseType baseado em isExport
            const responseType = isExport ? 'blob' : 'json';

            const params = {
                pagination: pagination.pageSize,
                page: page,
                typeData: tipoData
            };

            if (searchFilters.status) {
                params.situation = searchFilters.status;
            }

            if (searchFilters.user_id) {
                params.user_id = searchFilters.user_id;
            }

            if (searchFilters.number_contract) {
                params.number_contract = searchFilters.number_contract;
            }

            if (searchFilters.dateRange.length > 0) {
                params.datestart = dayjs(searchFilters.dateRange[0]).format('YYYY-MM-DD');
                params.dateend = dayjs(searchFilters.dateRange[1]).format('YYYY-MM-DD');
            }

            if (searchFilters?.specialties?.length > 0) {
                params.specialties = searchFilters.specialties.map(item => item.value);
            }

            if (searchFilters.name) {
                params.name = searchFilters.name;
            }

            if (searchFilters.department_id) {
                params.department_id = searchFilters.department_id;
            }

            if (searchFilters.cpfCnpj) {
                params.cpf_cnpj = searchFilters.cpfCnpj;
            }

            params.isExport = isExport; // Adiciona o parâmetro de exportação

            const response = await ApiService.send(
                "get",
                `${process.env.REACT_APP_URL_API}documents/getfromcompany`,
                params,
                true,
                responseType // Usa a lógica do json e blob
            );

            if (isExport) {
                // Se for exportação, cria o download do blob
                const blob = new Blob([response], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                const downloadUrl = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.download = `companies_export_${new Date().toISOString().split('T')[0]}.xlsx`;
                link.click();
                URL.revokeObjectURL(downloadUrl);
            } else {
                // Se não for exportação, trata a resposta JSON normalmente
                const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);
                setArrayCompany(data || []);
                setPagination(pagInfo || {current: 1, pageSize: 10, total: 0});
            }
        } catch (error) {
            console.log(error);
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    const handleSearchFiltersChange = (field, value) => {
        setSearchFilters(prevFilters => ({
            ...prevFilters,
            [field]: value
        }));
    };


    const handleClearFilters = () => {
        setSearchFilters({
            dateRange: [],
            status: "",
            name: "", // Limpar o nome do usuário
            cpfCnpj: "", // Limpar o filtro de CPF/CNPJ
            user_id: "", // Limpar o filtro de CPF/CNPJ
        });
        setPagination({...pagination, current: 1});
        fetchArrayCompany();
    };

    const handleApprove = (user) => {
        handleStatusChange('accepted', user);
    };

    const handleReject = (user) => {
        handleStatusChange('refused', user);
    };

    const handleStatusChange = (status, user) => {
        setLoading(true);

        const data = {
            user_interested: user.user_info.id,
            situation: status,
        };

        // Define a rota com base no status
        const endpoint = status === 'accepted'
            ? `${process.env.REACT_APP_URL_API}documents/approve`
            : `${process.env.REACT_APP_URL_API}documents/reject`;

        ApiService.send("post", endpoint, data, true)
            .then((res) => {
                if (res.code === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Sucesso!',
                        text: `Solicitação ${status === 'accepted' ? 'aprovada' : 'rejeitada'} com sucesso.`,
                    }).then(() => {
                        fetchArrayCompany(pagination.current);
                    });
                }
            })
            .catch((error) => {
                console.error(`Erro ao ${status === 'accepted' ? 'aprovar' : 'rejeitar'} solicitação:`, error);
                Swal.fire({
                    icon: 'error',
                    title: 'Erro!',
                    text: error.response?.data?.message || `Ocorreu um erro ao ${status === 'accepted' ? 'aprovar' : 'rejeitar'} a solicitação.`,
                });
            })
            .finally(() => {
                setLoading(false);
            });
    };


    const handleAddDocument = () => {
        setShowDocTypeModal(true);
    };

    const onUserSelect = (users) => {
        setSearchFilters({...searchFilters, user_id: users?.value || null});
    };


    const handleImport = () => {
        setShowImportModal(true);
    };

    const handleUserRegister = (company = null) => {
        setShowUserRegisterModal(true);
        setSelectedUser(company);
    };


    const handleUserDueDate = (company = null) => {
        // helpers de formatação
        const toBR = (iso) => {
            if (!iso) return '';
            const [y,m,d] = (iso || '').split('-');
            if (!y || !m || !d) return '';
            return `${d.padStart(2,'0')}/${m.padStart(2,'0')}/${y}`;
        };

        // valores atuais do registro (se existirem)
        const currentDateBR = toBR(company?.due_date);
        const currentContract = company?.number_contract || '';

        setDropdownOpenId(null);

        Swal.fire({
            title: `<span>Informe os dados</span> <br/><strong> ${company?.user_info?.name}</strong>`,
            html: `
      <div class="prx-form">
        <div class="prx-field">
          <label class="prx-label">Data de Vencimento</label>
          <input id="prx-date" type="text" inputmode="numeric" placeholder="dd/mm/aaaa" class="prx-input" />
          <div class="prx-hint">Ex.: 31/12/2025</div>
        </div>
        <div class="prx-field">
          <label class="prx-label">Número do Contrato</label>
          <input id="prx-contract" type="text" placeholder="Digite o número do contrato" class="prx-input" />
        </div>
      </div>
    `,
            showCancelButton: true,
            confirmButtonText: 'Salvar',
            cancelButtonText: 'Cancelar',
            reverseButtons: true,
            focusConfirm: false,
            width: 560,
            customClass: {
                popup: 'prx-modal',
                title: 'prx-title',
                confirmButton: 'prx-btn prx-btn-primary',
                cancelButton: 'prx-btn prx-btn-gray'
            },
            willOpen: () => {
                if (!document.getElementById('prx-modal-styles')) {
                    const style = document.createElement('style');
                    style.id = 'prx-modal-styles';
                    style.textContent = `
   .swal2-container{
  background: rgba(0,0,0,.85) !important;
  backdrop-filter: blur(6px);
  z-index: 2147483647 !important; /* acima de tudo */
}

/* caixa do modal */
.prx-modal{
  padding: 28px 32px 26px;
  border-radius: 20px !important;
}

/* título do modal (fundo claro) */
.prx-title{
  font-size: 22px !important;
  font-weight: 700 !important;
  margin-bottom: 18px !important;
  color: #111827; /* bem legível no fundo branco */
  text-align: center;
}

/* layout dos campos */
.prx-form{ display: grid; gap: 16px; }
.prx-field{ display: grid; gap: 8px; }

/* labels e hint com contraste correto pro fundo claro do modal */
.prx-label{
  font-weight: 700;
  color: #334155;           /* slate-700: visível no branco */
  letter-spacing: .2px;
}
.prx-hint{
  font-size: 12px;
  color: #64748b;           /* slate-500 */
}

/* inputs escuros, legíveis e com foco bonito */
.prx-input{
  width: 100% !important;
  height: 46px;
  border: 1px solid #334155;  /* borda visível */
  border-radius: 12px;
  padding: 0 14px;
  outline: none;
  background: #1f2937;        /* slate-800 (dark) */
  color: #ffffff;
  font-size: 15px;
  transition: box-shadow .2s ease, border-color .2s ease, background .2s ease;
}
.prx-input::placeholder{ color: #94a3b8; } /* slate-400 */
.prx-input:focus{
  border-color: #818cf8;       /* indigo-400 */
  box-shadow: 0 0 0 3px rgba(129,140,248,.30);
}

/* botões */
.prx-btn{
  min-width: 120px;
  height: 44px !important;
  border-radius: 12px !important;
  font-weight: 700 !important;
  font-size: 15px !important;
}
.prx-btn-primary{
  background: linear-gradient(90deg, #6366f1, #4f46e5) !important;
  color: #fff !important;
  border: none !important;
}
.prx-btn-primary:hover{ filter: brightness(.95); }
.prx-btn-gray{
  background: #6b7280 !important;  /* gray-600 */
  color: #fff !important;
  border: none !important;
}
.prx-btn-gray:hover{ background: #4b5563 !important; }

/* esconde inputs padrão do SweetAlert */
.swal2-input{ display: none !important; }
    `;
                    document.head.appendChild(style);
                }
            },
            didOpen: () => {
                const date = document.getElementById('prx-date');
                const contract = document.getElementById('prx-contract');

                // PRÉ-PREENCHER com valores existentes
                if (currentDateBR) date.value = currentDateBR;
                if (currentContract) contract.value = currentContract;

                // máscara dd/mm/aaaa
                date.addEventListener('input', (e) => {
                    let v = e.target.value.replace(/\D/g, '').slice(0, 8);
                    if (v.length >= 5) v = v.replace(/^(\d{2})(\d{2})(\d{0,4}).*/, '$1/$2/$3');
                    else if (v.length >= 3) v = v.replace(/^(\d{2})(\d{0,2}).*/, '$1/$2');
                    e.target.value = v;
                });

                contract.setAttribute('maxlength', '40');

                // foco: se já tem data, vai pro contrato; senão fica na data
                (currentDateBR ? contract : date).focus();
            },
            preConfirm: () => {
                const rawDate = (document.getElementById('prx-date').value || '').trim();
                const number_contract = (document.getElementById('prx-contract').value || '').trim();

                const m = rawDate.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
                if (!m) return Swal.showValidationMessage('Informe a data no formato dd/mm/aaaa.');
                const [_, dd, mm, yyyy] = m;
                const iso = `${yyyy}-${mm}-${dd}`;


                return { due_date: iso, number_contract };
            }
        }).then((result) => {
            if (result.isConfirmed && result.value) {
                const { due_date, number_contract } = result.value;

                Swal.fire({
                    title: 'Salvando...',
                    didOpen: () => Swal.showLoading(),
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    showConfirmButton: false
                });

                ApiService.send(
                    "put",
                    `${process.env.REACT_APP_URL_API}documents/update-duedate-user`,
                    { due_date, number_contract, user_interested: company?.user_info?.id },
                    true
                )
                    .then((res) => {
                        if (res.code === 200) {
                            Swal.fire({ icon: 'success', title: 'Sucesso!' })
                                .then(() => fetchArrayCompany(pagination.current));
                        } else {
                            Swal.fire({ icon: 'warning', title: 'Retorno inesperado', text: 'Tente novamente.' });
                        }
                    })
                    .catch((error) => {
                        Swal.fire({
                            icon: 'error',
                            title: 'Erro!',
                            text: error?.response?.data?.message || 'Ocorreu um erro ao alterar.'
                        });
                    })
                    .finally(() => setLoading(false));
            }
        });
    };




    const closeUserRegister = (save = false) => {
        setShowUserRegisterModal(false);
        if (save) {
            fetchArrayCompany(pagination.current, false);
        }

    };
    const closeCommentsModal = (save = false) => {
        setShowCommentsModal(false);
        setSelectedUser(null)
        if(save) {
            fetchArrayCompany(pagination.current, false);
        }
    };


    const handleAnalysisDocument = (user) => {
        setSelectedUser(user);
        setShowAnalysisUserModal(true);
    };

    const handleModalComments = (user) => {
        setSelectedUser(user);
        setShowCommentsModal(true);
    };

    const fetchListCompanyAssistant = async () => {

        try {
            const companyId = AuthService.getCompanyId();
            setDataConfig([]);
           if(companyId) {
               const response = await ApiService.send(
                   "get",
                   `${process.env.REACT_APP_URL_API}users/list-assistant`,
                   {id: companyId},
                   true
               );

               const {data} = ApiService.handleApiResponse(response);

               setDataConfig(data);
           }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };
    const handleChange = (event) => {
        const {name, value} = event.target;
        setSearchFilters((prevUsers) => ({
            ...prevUsers,
            [name]: value,
        }));
    };


    const handlePageChange = (page) => {

        fetchArrayCompany(page, false);

    };


    const handleDepartmentUserModalClose = (save = false) => {
        setShowDepartmentUserModal(false);

        if(save){
            fetchArrayCompany(pagination.current);
        }

    };

    const handlespecialtyUserModalClose = (save = false) => {
        setShowSpecialtiesUserModal(false);
        if(save){
            fetchArrayCompany(pagination.current);
        }

    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Usuário" pageTitle="Credenciamento"/>
                    <Row>
                        <div className="d-flex justify-content-end mb-3">
                            <div className="button-group">
                                <button type="button" className="btn btn-outline-primary"
                                        onClick={() => handleShowSelectDocTypeModal()}>
                                    <i className="fa fa-list"></i> Selecionar Documento
                                </button>

                                <button type="button" className="btn btn-outline-info position-relative"
                                        onClick={() => handleShowConfigModal()}>
                                    <i className="fa fa-gear"></i> Configurar
                                    <span
                                        className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                                        title="Usuário que Tentou Credenciar."
                                        style={{fontSize: '0.75rem'}}
                                    >
                                            {dataConfig?.qtd_interest || 0}
                                          </span>
                                </button>

                                <button type="button" className="btn btn-outline-dark" onClick={() => handleImport()}>
                                    <i className="fa fa-upload"></i> Importar
                                </button>
                            </div>
                        </div>

                        <div className="row mt-2">
                            <div className="col-md-4">
                                <div className="form-group">
                                    <div className="btn-group" role="group">
                                        <button
                                            type="button"
                                            className={`btn btn-sm ${tipoData === 'due_date' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => {
                                                setTipoData('due_date');
                                                handleSearchFiltersChange('typeData', 'due_date');
                                            }}
                                        >
                                            Data Vencimento
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn btn-sm ${tipoData === 'updated_at' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => {
                                                setTipoData('updated_at');
                                                handleSearchFiltersChange('typeData', 'updated_at');
                                            }}
                                        >
                                            Data Cadastro
                                        </button>
                                    </div>
                                    <div className="form-control">
                                        <RangePicker
                                            style={{border: "none", boxShadow: "none"}}
                                            variant="outlined"
                                            locale={locale}
                                            format="DD/MM/YYYY"
                                            className="range-picker-custom"
                                            value={searchFilters.dateRange}
                                            onChange={(dates) =>
                                                handleSearchFiltersChange("dateRange", dates ? [dates[0], dates[1]] : [])
                                            }
                                        />
                                    </div>
                                </div>
                            </div>


                            <div className="col-md-4">
                                <div className="form-group">
                                    <label className="mb-2">Situação</label>
                                    <Select
                                        placeholder="Selecione Status"
                                        style={{width: "100%"}}
                                        options={statusOptions}
                                        value={statusOptions.find(option => option.value === searchFilters.status)}
                                        onChange={(selectedOption) => handleSearchFiltersChange("status", selectedOption?.value || "")}
                                        menuPortalTarget={document.body} // Renderiza o menu fora do contêiner pai
                                        styles={{
                                            menuPortal: base => ({
                                                ...base,
                                                zIndex: 9999
                                            }), // Definindo z-index alto
                                            menu: base => ({...base, zIndex: 9999}) // Ajuste de z-index no próprio menu
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <UsersSearch
                                        onUserSelect={onUserSelect}
                                         situation={null}
                                    />
                                </div>
                            </div>
                            <div className="col-3 form-group">
                                <label>Especialidades</label>
                                <Select
                                    isMulti
                                    ref={selectInputRef}
                                    value={searchFilters.specialties || []}
                                    onChange={(selectedOptions) =>
                                        setSearchFilters({
                                            ...searchFilters,
                                            specialties: selectedOptions || []
                                        })

                                    }
                                    options={specialtyOptions}
                                    placeholder="Selecione"
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: base => ({...base, zIndex: 9999}),
                                        menu: base => ({...base, zIndex: 9999}),
                                    }}
                                />
                            </div>
                            <div className="col-md-3 form-group">
                                <label>Departamentos</label>
                                <Select
                                    isClearable
                                    options={departmentsFilter.map((dept) => ({
                                        value: dept.id,
                                        label: dept.name,
                                    }))}
                                    onChange={(dept) =>
                                        setSearchFilters((prevFilters) => ({
                                            ...prevFilters,
                                            department_id: dept?.value || "",
                                        }))}

                                    classNamePrefix="select"
                                    placeholder="Selecionar Departamento..." // Define o texto interno
                                    menuPortalTarget={document.body} // Renderiza o menu fora do contêiner pai
                                    styles={{
                                        menuPortal: base => ({
                                            ...base,
                                            zIndex: 9999
                                        }), // Definindo z-index alto
                                        menu: base => ({...base, zIndex: 9999}) // Ajuste de z-index no próprio menu
                                    }}
                                />

                            </div>

                            <div className="col-md-3 form-group">
                                <label>Nº Contrato</label>
                                <Input
                                    className="form-control"
                                    type="text"
                                    name="number_contract"
                                    value={searchFilters?.number_contract}
                                    onChange={handleChange}
                                    placeholder="Numero do contrato"
                                />


                            </div>
                        </div>
                        <div className="row ">
                            <div className="col-md-12 d-flex justify-content-end">
                                <button type="button" className="mr-1 me-2 btn"
                                        onClick={() => handleClearFilters()}>
                                    <i className="fa fa-eraser"></i> Limpar Filtros
                                </button>
                                <button type="button" className="mr-1 me-2 btn btn-dark"
                                        onClick={() => fetchArrayCompany(1, true)}>
                                    <i className="fa fa-file-excel-o"></i> Exportar
                                </button>
                                <button type="button" className="mr-1 me-2 btn btn-info"
                                        onClick={() => handleUserRegister(null)}>
                                    <i className="fa fa-plus"></i> Novo Usuário
                                </button>

                                <button
                                    type="button"
                                    className="mr-1 me-2 btn btn-success"
                                    onClick={() => fetchArrayCompany(1, false)}
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status"
                                                  aria-hidden="true"></span>
                                            Buscando...
                                        </>
                                    ) : (
                                        <>
                                            <i className="fa fa-search me-1"></i> Buscar
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>


                        <div className="list-container mt-4">
                            {loading ? (
                                <Skeleton count={5}/>
                            ) : (
                                arrayCompany.length > 0 ? (
                                    arrayCompany.map((company) => (
                                        <Col lg={12} key={company.id}>
                                            <Card className=" shadow-sm card-hover">
                                                <CardBody
                                                    className="card-body d-flex justify-content-between align-items-center p-2">

                                                    <div className="col-12 col-sm-7 col-md-6 d-flex align-items-center">
                                                        <div className="col-2 me-3">
                                                            <Avatar
                                                                src={company.user_info?.profile_image || process.env.REACT_APP_URL_STORAGE + "src/perfil_icone.png"}
                                                                alt={company.user_info?.name}
                                                                size={60}
                                                                className="me-2"
                                                            />
                                                        </div>
                                                        <div className="col-8 ms-2">
                                                            <h6 className="doc-name">{company?.user_info?.name || "Usuário não identificado"}</h6>
                                                            <p className="text-muted mb-1">
                                                                <i className="fa fa-phone text-info me-2"></i>
                                                                <strong>Telefone:</strong> {company.user_info?.ddd && company.user_info?.phone ? `(${company.user_info.ddd}) ${company.user_info.phone}` : "Não informado"}
                                                            </p>
                                                            <p className="text-muted mb-1">
                                                                <i className="fa fa-hospital-o text-info me-2"></i>
                                                                <strong>Departamento:</strong>{" "}
                                                                {company.departments?.length > 0
                                                                    ? company.departments.join(", ")
                                                                    : "Não informado"}
                                                            </p>
                                                            <p className="text-muted mb-1">
                                                                <i className="fa fa-dochub text-info me-2"></i>
                                                                <strong>Especialidade:</strong>{" "}
                                                                {company.specialties?.length > 0
                                                                    ? company.specialties.join(", ")
                                                                    : "Não informado"}
                                                            </p>

                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-sm-5 col-md-3 small">
                                                        <p className="mb-1">
                                                            <i className="fa fa-calendar me-2 text-info"></i>
                                                            <strong>Cadastro:</strong> {moment(company.created_at).format('DD/MM/YYYY HH:mm')}
                                                        </p>
                                                        <p className="mb-1">
                                                            <i className="fa fa-refresh me-2 text-info"></i>
                                                            <strong>Atualização:</strong> {moment(company.updated_at).format('DD/MM/YYYY HH:mm')}
                                                        </p>
                                                        <p className="mb-1">
                                                            <i className="fa fa-calendar-times-o me-2 text-info"></i>
                                                            <strong>Vencimento: </strong>
                                                            <span
                                                                className={
                                                                    !company.due_date || !moment(company.due_date, 'YYYY-MM-DD', true).isValid()
                                                                        ? 'text-danger'
                                                                        : moment(company.due_date).isSameOrBefore(moment(), 'day')
                                                                            ? 'text-danger'
                                                                            : 'text-primary'
                                                                }
                                                            >
                                                              {company.due_date && moment(company.due_date).isValid()
                                                                  ? moment(company.due_date).format('DD/MM/YYYY')
                                                                  : 'Inválido'}



                                                            </span>



                                                            <button type="button"
                                                                    onClick={() => handleUserDueDate(company)}
                                                                    className="btn btn-sm btn-link"><i
                                                                className="fa fa-edit"></i></button>
                                                        </p><p className="mb-1">
                                                            <i className="fa fa-file me-2 text-info"></i>
                                                            <strong>Contrato: </strong>


                                                        <span
                                                            className={
                                                                !company.number_contract
                                                                    ? 'text-danger'
                                                                    : moment(company.due_date).isSameOrBefore(moment(), 'day')
                                                                        ? 'text-danger'
                                                                        : 'text-primary'
                                                            }
                                                        >
                                                            {company.number_contract
                                                                ? company.number_contract
                                                                : 'Sem '}

                                                        </span>
                                                            <button type="button"
                                                                    onClick={() => handleUserDueDate(company)}
                                                                    className="btn btn-sm btn-link"><i
                                                                className="fa fa-edit"></i></button>
                                                        </p>
                                                        <p className="mb-1">
                                                            <i className="fa fa-info-circle text-info me-2"></i>
                                                            <strong>Situação:</strong> &nbsp;
                                                            {company.situation === "pending" && (
                                                                <span className="text-warning"><i
                                                                    className="fa fa-hourglass-start mr-1"></i> Pendente</span>
                                                            )}
                                                            {company.situation === "accepted" && (
                                                                <span className="text-success"><i
                                                                    className="fa fa-check-circle mr-1"></i> Aprovado</span>
                                                            )}
                                                            {company.situation === "refused" && (
                                                                <span className="text-danger"><i
                                                                    className="fa fa-times-circle mr-1"></i> Rejeitado</span>
                                                            )}
                                                            {company.situation === "remake" && (
                                                                <span className="text-danger"><i
                                                                    className="fa fa-address-card mr-1"></i> Recusar Doc.</span>
                                                            )}
                                                        </p>
                                                    </div>



                                                    <div className="dropdown">

                                                        <button
                                                            className="btn btn-outline-info btn-sm  me-5"
                                                            type="button"
                                                            ref={(el) => (buttonRefs.current[company.id] = el)}
                                                            onClick={() =>
                                                                setDropdownOpenId(dropdownOpenId === company.id ? null : company.id)
                                                            }
                                                        >
                                                            <i className="fa fa-ellipsis-v"></i> Opções
                                                        </button>

                                                        <DropdownPortal
                                                            parentRef={{current: buttonRefs.current[company.id]}}
                                                            show={dropdownOpenId === company.id}
                                                            onClose={() => setDropdownOpenId(null)}
                                                        >
                                                            <ul className="dropdown-menu show">
                                                                <li>
                                                                    <button type="button"
                                                                            className="dropdown-item"
                                                                            onClick={() => {
                                                                                handleAnalysisDocument(company);
                                                                                setDropdownOpenId(null);
                                                                            }}
                                                                    >
                                                                        <i className="fa fa-search me-1"></i> Analisar
                                                                    </button>
                                                                </li>
                                                                {company.situation !== "accepted"  && (
                                                                <li>
                                                                    <button type="button"
                                                                            className="dropdown-item"
                                                                            onClick={() => {
                                                                                handleApprove(company);
                                                                                setDropdownOpenId(null);
                                                                            }}
                                                                    >
                                                                        <i className="fa fa-check me-1"></i> Aprovar
                                                                    </button>
                                                                </li>
                                                                    )}
                                                                <li>
                                                                    <button type="button"
                                                                            className="dropdown-item"
                                                                            onClick={() => {
                                                                                handleShowDepartmentUserModal(company);
                                                                                setDropdownOpenId(null);
                                                                            }}
                                                                    >
                                                                        <i className="fa fa-hospital-o me-1"></i> Departamento
                                                                    </button>
                                                                </li>
                                                                <li>
                                                                    {company.user_info.email_verified_at ? (
                                                                        <OverlayTrigger
                                                                            placement="top"
                                                                            overlay={
                                                                                <Tooltip
                                                                                    id={`tooltip-${company.user_info.id}`}>
                                                                                    Conta já foi ativada pelo usuário.
                                                                                    Alterações devem ser feitas
                                                                                    diretamente por ele.
                                                                                </Tooltip>
                                                                            }
                                                                        >
                                                                            <span className="d-inline-block w-100">
                                                                                <button
                                                                                    type="button"
                                                                                    disabled={true}
                                                                                    className="dropdown-item"
                                                                                    style={{pointerEvents: 'auto'}}
                                                                                >
                                                                                    <i className="fa fa-edit me-1"></i> Editar
                                                                                </button>
                                                                            </span>
                                                                        </OverlayTrigger>
                                                                    ) : (
                                                                        <button type="button"
                                                                                className="dropdown-item"
                                                                                onClick={() => {
                                                                                    handleUserRegister(company);
                                                                                    setDropdownOpenId(null);
                                                                                }}
                                                                        >
                                                                            <i className="fa fa-edit me-1"></i> Editar
                                                                        </button>
                                                                    )}
                                                                </li>
                                                                <li>
                                                                    <button type="button"
                                                                            className="dropdown-item"
                                                                            onClick={() => {
                                                                                handleShowSpecialtiesUserModal(company);
                                                                                setDropdownOpenId(null);
                                                                            }}
                                                                    >
                                                                        <i className="fa fa-dochub me-1"></i> Especialidade
                                                                    </button>
                                                                </li>
                                                                <li>
                                                                    <div className="position-relative mb-1">
                                                                        <button type="button"
                                                                                className="dropdown-item"
                                                                                onClick={() => {
                                                                                    handleModalComments(company);
                                                                                    setDropdownOpenId(null);
                                                                                }}
                                                                        >
                                                                            <i className="fa fa-comment me-1"></i> Avaliar
                                                                        </button>
                                                                        {company?.history?.length > 0 && (
                                                                            <span
                                                                                className="position-absolute top-50 start-100 translate-middle badge rounded-pill bg-danger"
                                                                                style={{fontSize: '0.65rem'}}
                                                                                title="Tentativas de credenciamento"
                                                                            >
                                                                            {company.history.length}
                                                                        </span>
                                                                        )}
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    {(company.situation === "pending" || company.situation === "remake") && (
                                                                        <button type="button"
                                                                                className="dropdown-item"
                                                                                onClick={() => {
                                                                                    handleReject(company);
                                                                                    setDropdownOpenId(null);
                                                                                }}
                                                                        >
                                                                            <i className="fa fa-times me-1"></i> Rejeitar
                                                                        </button>
                                                                    )}
                                                                </li>
                                                            </ul>

                                                        </DropdownPortal>
                                                    </div>


                                                </CardBody>
                                            </Card>
                                        </Col>
                                    ))
                                ) : (
                                    <div className="card duty-card shadow-sm mb-3">
                                        <div className="card-body">
                                            <div className="alert alert-primary" role="alert">Nenhuma
                                                solicitação
                                                encontrada.
                                            </div>
                                        </div>
                                    </div>
                                )
                            )}

                            <CustomPagination
                                className="mt-4"
                                pagination={pagination}
                                onChange={handlePageChange}
                            />
                        </div>

                        <DocumentSelectRequiredModal
                            show={showSelectDocTypeModal}
                            onHide={handleHideSelectDocTypeModal}
                            onSave={handleShowDocTypeModal}
                            handleAddDocument={handleAddDocument}
                        />

                        <DocumentDocTypeModal
                            show={showDocTypeModal}
                            onHide={handleHideDocTypeModal}
                            initialData={docTypeModalData}
                        />

                        {showConfigModal && (
                            <ModalCompanyConfigAccreditation
                                show={showConfigModal}
                                onHide={handleHideConfigModal}
                            />
                        )}
                        <ImportModal
                            show={showImportModal}
                            onHide={handleHideImportModal}
                            initialData={docTypeModalData}
                            importType={1}
                        />

                        <AnalysisUserModal
                            show={showAnalysisUserModal}
                            onHide={handleHideAnalysisUserModal}
                            initialData={selectedUser}
                        />

                        <UserRegisterModal
                            show={showUserRegisterModal}
                            onHide={closeUserRegister}
                            initialData={selectedUser}
                        />

                        <AccreditationCommentsModal
                            show={showCommentsModal}
                            onHide={closeCommentsModal}
                            user={selectedUser}
                        />

                        {showDepartmentUserModal && (
                            <DepartmentUserModal
                                show={showDepartmentUserModal}
                                onHide={handleDepartmentUserModalClose}
                                userInit={selectedUser?.user_info}
                            />
                        )}

                        {showSpecialtiesUserModal && (
                            <SpecialtiesUserModal
                                show={showSpecialtiesUserModal}
                                onHide={handlespecialtyUserModalClose}
                                userInit={selectedUser?.user_info}
                            />
                        )}
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default AccreditationCompany;
